import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

export default function RSVPCallout() {
  return (
    <section
      id="rsvp"
      data-testid="rsvp-section"
      className="bg-[#FAF9F6] pt-0 pb-16 md:pb-24 px-6"
    >
      <div className="max-w-7xl mx-auto">
        <Link
          to="/rsvp"
          data-testid="rsvp-cta"
          className="group block bg-[#6A1E2D] hover:bg-[#521723] transition-colors duration-300 p-8 md:p-10 text-[#FAF9F6]"
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="flex items-start gap-5">
              <Heart className="w-7 h-7 text-[#A3C1DA] shrink-0 mt-1" strokeWidth={1.4} />
              <div>
                <p className="text-[10px] tracking-luxe uppercase text-[#A3C1DA] mb-2">
                  The favour of a reply
                </p>
                <h3 className="font-display text-3xl md:text-4xl font-light leading-tight mb-2">
                  Will you join us?
                </h3>
                <p className="text-sm md:text-base text-[#FAF9F6]/80 leading-relaxed max-w-2xl">
                  Kindly reply by <strong className="font-medium">1st March 2027</strong> so we can finalise the seating chart and our caterers can make sure everyone's well fed.
                </p>
              </div>
            </div>
            <span className="inline-flex items-center gap-3 text-xs tracking-luxe uppercase shrink-0 group-hover:gap-4 transition-all self-start md:self-center">
              Send our reply
              <ArrowRight className="w-4 h-4" strokeWidth={1.6} />
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}
